import React from 'react';
import { Box } from 'wix-style-react';
import { Logo } from '../Logo';
import { InfoLine } from '../InfoSection';
export var InvoiceHeader = function (_a) {
    var background = _a.background, businessName = _a.businessName, logo = _a.logo, onImageReady = _a.onImageReady;
    return (React.createElement(Box, { paddingTop: "12px", paddingBottom: "12px", align: "center", direction: "vertical", background: background },
        React.createElement(Logo, { logo: logo, onImageReady: onImageReady }),
        React.createElement(InfoLine, { paddingTop: "8px", weight: "bold" }, businessName)));
};
//# sourceMappingURL=InvoiceHeader.js.map